export default {"src":"/_next/static/media/icon-logo-facebook.c540e010.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};